import { useReducer, useState, useEffect } from "react";
import { useQuery } from "@tanstack/react-query";
import { useSelector } from "react-redux";
import { QUERRYIDS } from "../constants/queryIds";
import { fetchFaqs } from "../Apis/faqs";
import {
  mapFaqs,
  mapFaqsCategories,
  mapFaqsCategoriesIds,
  mapFaqsIds,
} from "../constants/map/faqs";
import { getUserIdFromState } from "../mappers/backendMappers";

const faqsReducer = (state, action) => {
  switch (action.type) {
    case "fetchFaqs": {
      // Handle the data directly as it's already an array from the API
      const data = action.payload;
      return {
        ...state,
        faqs: mapFaqs(data),
        faqsIds: mapFaqsIds(data),
        faqsCategory: mapFaqsCategories(data),
        faqsCategoryIds: mapFaqsCategoriesIds(data),
      };
    }
    default: {
      throw new Error(`Unhandled action type: ${action.type}`);
    }
  }
};

const useFaqs = () => {
  // Get userId and csrfToken from Redux
  const userId = useSelector(getUserIdFromState);
  const csrfToken = useSelector(
    ({ applicationUser }) => applicationUser?.token
  );

  // Initialize search text from URL query parameter if present
  const getInitialSearchText = () => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get("search");
    return searchParam || "";
  };

  const [searchFaqText, setSearchFaqText] = useState(getInitialSearchText);
  const [state, dispatch] = useReducer(faqsReducer, {
    faqs: [],
    faqsIds: [],
    faqsCategory: {},
    faqsCategoryIds: [],
  });

  const { faqs, faqsIds, faqsCategory, faqsCategoryIds } = state;

  // Update search text when URL changes
  useEffect(() => {
    const urlParams = new URLSearchParams(window.location.search);
    const searchParam = urlParams.get("search");
    if (searchParam && searchParam !== searchFaqText) {
      setSearchFaqText(searchParam);
    }
  }, []);

  const fetchAFaqs = useQuery(
    [QUERRYIDS.fetchFaqs, searchFaqText, userId, csrfToken],
    () => fetchFaqs(searchFaqText, userId, csrfToken),
    {
      enabled: !!csrfToken, // Only run query when csrfToken is available
      onSuccess: (data) =>
        dispatch({
          type: "fetchFaqs",
          payload: data,
        }),
    }
  );

  const search = (e) => {
    setSearchFaqText(e.target.value);
  };

  return {
    faqs,
    faqsIds,
    faqsCategory,
    faqsCategoryIds,
    search,
    searchFaqText,
    loading: fetchAFaqs.isLoading,
  };
};

export default useFaqs;
